<template>
  <div class="custom-sort-order">
    <div v-if="rowIndex == 0">
      <button
        type="button"
        class="btn btn-sm2 btn-default datatables-block__table__row__button--sort button--sort-down"
        @click="sortDown(rowData, rowIndex)"
      >
        <i class="fa fa-long-arrow-down"></i>
      </button>
    </div>
    <div v-else-if="rowIndex + 1 == result_data.length">
      <button
        type="button"
        class="btn btn-sm2 btn-default datatables-block__table__row__button--sort button--sort-up"
        @click="sortUp(rowData, rowIndex)"
      >
        <i class="fa fa-long-arrow-up"></i>
      </button>
    </div>
    <div v-else>
      <button
        type="button"
        class="btn btn-sm2 btn-default datatables-block__table__row__button--sort button--sort-up"
        @click="sortUp(rowData, rowIndex)"
      >
        <i class="fa fa-long-arrow-up"></i>
      </button>
      <button
        type="button"
        class="btn btn-sm2 btn-default datatables-block__table__row__button--sort button--sort-down"
        @click="sortDown(rowData, rowIndex)"
      >
        <i class="fa fa-long-arrow-down"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    result_data: {
      type: Array,
      required: true,
    },
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
    rowKey: String,
  },
  mounted() {},
  methods: {
    sortDown(data, index) {
      this.$emit('reload');
      var dataOrder = [];
      var rowKey = this.rowKey;
      if (this.result_data[index + 1] != undefined) {
        dataOrder.push({
          id: this.result_data[index][rowKey],
          sort_order: this.result_data[index + 1].sort_order,
        });
        dataOrder.push({
          id: this.result_data[index + 1][rowKey],
          sort_order: this.result_data[index].sort_order,
        });
      }

      this.$emit('on-switch-orders', {
        dataOrder,
      });
    },
    sortUp(data, index) {
      this.$emit('reload');
      var dataOrder = [];
      var rowKey = this.rowKey;
      if (this.result_data[index - 1] != undefined) {
        dataOrder.push({
          id: this.result_data[index][rowKey],
          sort_order: this.result_data[index - 1].sort_order,
        });
        dataOrder.push({
          id: this.result_data[index - 1][rowKey],
          sort_order: this.result_data[index].sort_order,
        });
      }
      this.$emit('on-switch-orders', {
        dataOrder,
      });
    },
  },
};
</script>

<style>
.btn-sm2 {
  padding: 2px 8px 0;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}
</style>
